import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const colClasses = {
    2: 'lg:grid-cols-2',
    3: 'lg:grid-cols-3',
    4: 'lg:grid-cols-4'
};
/**
 * PageGrid provides a responsive grid layout for cards.
 * - 1 column on mobile
 * - 2 columns on tablet (md)
 * - Configurable columns on desktop (lg)
 *
 * @example
 * <PageGrid cols={3}>
 *   {items.map(item => <ItemCard key={item.id} item={item} />)}
 * </PageGrid>
 */ export function PageGrid({ children, cols = 3, className }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn('grid grid-cols-1 md:grid-cols-2 gap-6', colClasses[cols], className),
        children: children
    });
}
